import { createFileRoute, Link } from '@tanstack/react-router';
import { useCompetitions } from '@/data/competitions';
import { Button } from '@/components/ui/Button';
import { Empty } from '@/components/ui/Empty';

export const Route = createFileRoute('/admin/competitions/')({
  component: CompetitionsIndex,
});

function CompetitionsIndex() {
  const competitions = useCompetitions();

  return (
    <div className="space-y-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
            Comp team
          </p>
          <h1 className="mt-2">Competitions</h1>
        </div>
        <Link to="/admin/competitions/new">
          <Button>New competition</Button>
        </Link>
      </div>

      {competitions.isLoading && <p aria-live="polite">Loading…</p>}

      {competitions.data?.length === 0 && (
        <Empty
          title="No competitions yet"
          description="Add a competition to build the itinerary and start tracking placements."
          action={
            <Link to="/admin/competitions/new">
              <Button>Create competition</Button>
            </Link>
          }
        />
      )}

      {competitions.data && competitions.data.length > 0 && (
        <ul className="grid gap-3">
          {competitions.data.map((c) => (
            <li key={c.id} className="surface-elevated">
              <Link
                to="/admin/competitions/$id"
                params={{ id: c.id }}
                className="block p-5 hover:bg-[var(--color-surface-sunken)]"
              >
                <div className="flex flex-wrap items-baseline justify-between gap-3">
                  <h2 className="font-[var(--font-display)] text-[var(--text-xl)]">{c.name}</h2>
                  <p className="text-[var(--color-ink-muted)] text-[var(--text-sm)] tabular-nums">
                    {c.start_date}
                    {c.end_date !== c.start_date ? ` → ${c.end_date}` : ''}
                  </p>
                </div>
                <p className="mt-1 text-[var(--color-ink-muted)] text-[var(--text-sm)]">
                  {c.season}
                  {c.venue_name ? ` · ${c.venue_name}` : ''}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
